import React, { Component } from "react";
import StepWizard from "react-step-wizard";

//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import Paso1 from "../../pages/rueda/RuedaPaso1";
import Paso2 from "../../pages/rueda/RuedaPaso2";
import Paso3 from "../../pages/rueda/RuedaPaso3";
import Paso4 from "../../pages/rueda/RuedaPaso4";

export default class AdquisicionRueda extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.paso4 = React.createRef();

  }

  resetState = () => {
    this.setState(this.getInitialState());
  };

  getInitialState = () => ({
    cuentaOrigen: {},
    ctaFullData: {},
    grupo: {},
    nroOperacion: "",
    porSuerte: true,
    nroOperacion: "",
    nroContrato: "",
  });

  returnDataPaso1(_cuentaOrigen, _grupo, _ctaFullData) {
    this.setState({
      cuentaOrigen: _cuentaOrigen,
      ctaFullData: _ctaFullData,
      grupo: _grupo[0],
    });
  }

  returnDataPaso2(_porSuerte, _nroContrato) {
    this.setState({
      porSuerte: _porSuerte,
      nroContrato: _nroContrato,
    });
  }

  returnDataPaso3(_nroOperacion, _nroContrato, _sucursal, _cuenta, _pdfContrato) {
    this.setState({
      nroOperacion: _nroOperacion,
      nroContrato: _nroContrato,
      sucursal: _sucursal,
      cuentaAsignada: _cuenta,
      valoresPdf: _pdfContrato
    });
  }

  returnDataPaso4() {
    this.initDataChildren();
  }

  initDataChildren() {
    this.paso1.current.initData();
    this.paso2.current.resetState();
    this.paso4.current.resetState();
  }

  onStepChange = (stats) => {
    if (stats.previousStep === 2) {
      this.paso1.current.checkGrilla();
    }
  };

  initStorage = () => {
    sessionStorage.setItem("contratosNoDisponibles", "N");
  }

  actualizarNoDisponibles = (numeroContrato) => {

    let grupoAux = this.state.grupo;

    let contratosNoDisponibles = (grupoAux.atributoContratoRuedaDet !== undefined && grupoAux.atributoContratoRuedaDet !== null)
      ? grupoAux.atributoContratoRuedaDet
      : [];

    contratosNoDisponibles.push({
      estado: "A",
      fechaEstado: grupoAux.fechaModulo,
      grupo: grupoAux.id,
      numeroContrato
    });

    this.setState({
      ...this.state,
      grupo: grupoAux,
      nroContrato: -1
    });

    this.paso2.current.initNroContrato();

  }

  componentDidMount() {
    //setear storage de contratos
    this.initStorage();
  }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Adquisición de Rueda" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <StepWizard
                      onStepChange={this.onStepChange}
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        cuentaOrigen={this.state.cuentaOrigen}
                        grupo={this.state.grupo}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                      <Paso3
                        ref={this.paso3}
                        cuentaOrigen={this.state.cuentaOrigen}
                        grupo={this.state.grupo}
                        porSuerte={this.state.porSuerte}
                        nroContrato={this.state.nroContrato}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                        actualizarNoDisponibles={this.actualizarNoDisponibles.bind(this)}
                      />
                      <Paso4
                        ref={this.paso4}
                        cuentaOrigen={this.state.cuentaOrigen}
                        grupo={this.state.grupo}
                        nroOperacion={this.state.nroOperacion}
                        nroContrato={this.state.nroContrato}
                        ctaFullData={this.state.ctaFullData}
                        sucursal={this.state.sucursal}
                        pdfContrato={this.state.valoresPdf}
                        cuentaAsignada={this.state.cuentaAsignada}
                        returnDataPaso4={this.returnDataPaso4.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*************** MODAL INFORMATIVO ************************/}
        <div
          className="modal fade"
          id="modal-contrato-aleatorio"
          data-backdrop="false"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Adquisición de Rueda</h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    Aqui debe explicar al socio cual es la mecanica de la página
                    en general. "falta el texto explicativo"
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-cu-primary"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  Entendido
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
